import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { createUseStyles } from "$utils/createUseStyles";
import { Button, Text } from "$components";
import JOrderTree from "$components/JOrderTree/JOrderTree";
import { MESSAGES } from "$components/EDB/IntegratedOrders";
import { theme } from "$utils/theme/bataillog";
import { TreeProduct } from "$components/JOrderTree/types";
import { EDBIntegratedOrders } from "$types/EDBIntegratedOrders";
import { Order } from "$types";
import { edbIoToOrders, filterProduct, updateProductQuantity } from "./utils";

type Props = {
  currentAvailableOrders: Order[];
  handleOnCancel: () => void;
  onValidate: (integratedOrders: EDBIntegratedOrders) => void;
  setTmpIntegratedOrders: (integratedOrders: EDBIntegratedOrders) => void;
  tmpIntegratedOrders: EDBIntegratedOrders;
};

function Summary({
  currentAvailableOrders,
  handleOnCancel,
  onValidate,
  setTmpIntegratedOrders,
  tmpIntegratedOrders,
}: Props) {
  const classes = useStyles();
  const [allAvailableOrders, setAllAvailableOrders] = useState([]);

  // Cache all available orders
  useEffect(() => {
    const newOrders = currentAvailableOrders.filter((newOrder) =>
      allAvailableOrders.every((order2) => order2.id !== newOrder.id)
    );
    const allOrders = [...allAvailableOrders, ...newOrders];
    if (allOrders.length !== allAvailableOrders.length) {
      setAllAvailableOrders(allOrders);
    }
  }, [allAvailableOrders, currentAvailableOrders]);

  const handleOnProductQuantityChange = (
    newQuantity: number,
    product: TreeProduct
  ) => {
    const newIntegratedOrders = updateProductQuantity(
      tmpIntegratedOrders,
      product,
      newQuantity
    );
    setTmpIntegratedOrders(newIntegratedOrders);
  };

  const handleOnProductDelete = (treeProduct: TreeProduct) => {
    setTmpIntegratedOrders(filterProduct(tmpIntegratedOrders, treeProduct));
  };

  const handleOnValidate = () => {
    onValidate(tmpIntegratedOrders);
  };

  return (
    <Box flex={1} display="flex" flexDirection="column" minWidth="200px">
      <Text type="h3" className={classes.subtitle}>
        Récapitulatif
      </Text>

      {tmpIntegratedOrders?.orderProducts?.length > 0 ? (
        <JOrderTree
          expandAllNodes
          orders={edbIoToOrders(tmpIntegratedOrders).map((o) => ({
            ...o,
            hasOnlyOneSuborder:
              allAvailableOrders?.find((o2) => o2.id === o.id)?.suborders
                .length === 1,
          }))}
          onProductQuantityChange={handleOnProductQuantityChange}
          onProductDelete={handleOnProductDelete}
        />
      ) : (
        <Text>{MESSAGES.NO_INTEGRATED_PRODUCTS}</Text>
      )}

      <Box className={classes.actionBox}>
        <Button isDefault variant="outlined" onClick={handleOnCancel}>
          Annuler
        </Button>
        <Button onClick={handleOnValidate}>Valider</Button>
      </Box>
    </Box>
  );
}

const useStyles = createUseStyles(() => ({
  actionBox: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
  },
  subtitle: {
    fontWeight: "bold",
  },
}));

export default Summary;
